import type { ModalProps } from '@hover/blueprint';
import { Body, Button, Modal, useBreakpointValue } from '@hover/blueprint';
import React from 'react';

import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export interface ConfirmEmbedBackModalProps
  extends Omit<ModalProps, 'children'> {
  onDiscard: () => void;
}

export const ConfirmEmbedBackModal = ({
  onDiscard,
  ...props
}: ConfirmEmbedBackModalProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const discardText = useBreakpointValue(
    {
      base: t('topBar.confirmEmbedBackModal.discard'),
      tablet: t('topBar.confirmEmbedBackModal.discardChanges'),
    },
    {
      fallback: 'base',
    },
  );
  const { onClose } = props;

  return (
    <Modal
      footer={
        <>
          <Button onClick={onDiscard}>{discardText}</Button>
          <Button onClick={onClose} variant="secondary">
            {t('topBar.confirmEmbedBackModal.cancel')}
          </Button>
        </>
      }
      {...props}
      size={{ base: 'auto', tablet: 'small' }}
    >
      <Body mb={0} mt={100} width={{ base: 700, tablet: 'unset' }}>
        {t('topBar.confirmEmbedBackModal.body')}
      </Body>
    </Modal>
  );
};
